import { TransformedMasterData, WithItemLog } from '../../../../types/types'
import { BannerType } from '../../components/BannerLabel'
import {
  GetAllPlansResponse,
  GetPlanPricesResponse,
  PlanDetailById,
  PlanInfoById,
  PlanType,
  Price
} from '../../services/plan/types'

export enum ProtectionType {
  Domestic = 'domestic',
  Foreign = 'foreign'
}
export enum TravelType {
  Trip = 'trip',
  Yearly = 'yearly'
}

interface PlanLoadingState {
  isGetAllPlansLoading: boolean
  isExportPlansLoading: boolean
  isAddPlanLoading: boolean
  isDeletePlanLoading: boolean
  isDownloadCountryTemplateLoading: boolean
  isGetCountryIdListFromExcelLoading: boolean
  isExportPlanCountryByIdLoading: boolean
  isDownloadPriceTemplateLoading: boolean
  isGetPriceListFromExcelLoading: boolean
  isExportPlanPriceByIdLoading: boolean
  isGetPlanStatusLoading: boolean
  isGetPlanInfoLoading: boolean
  isGetPlanTypeLoading: boolean
  isGetPlanCountriesLoading: boolean
  isGetPlanPricesLoading: boolean
  isGetPlanSpecialLabelLoading: boolean
  isGetPlanDetailLoading: boolean
  isGetPlanExceptionLoading: boolean
  isGetPlanTimestampLoading: boolean
  isUpdatePlanStatusLoading: boolean
  isUpdatePlanInfoLoading: boolean
  isUpdatePlanTypeLoading: boolean
  isUpdatePlanCountriesLoading: boolean
  isUpdatePlanPricesLoading: boolean
  isUpdateSpecialLabelLoading: boolean
  isUpdatePlanDetailLoading: boolean
  isUpdatePlanExceptionLoading: boolean
  isDownloadPlanTemplateLoading: boolean
  isImportPlanTemplateLoading: boolean
}

export interface PlanState extends PlanLoadingState {
  // state
  prices: Price[]
  yearPrice: string
  isPlanActive: boolean
  protectionType: ProtectionType
  travelType: TravelType
  bannerType: BannerType
  filteredRegions: string[]
  selectedPlanCountries: string[]
  currentAbbreviationName: string
  allCountriesList: TransformedMasterData[]
  planFile: File | null
  tax: string
  insurancePrice: string
  // fetched
  plans?: GetAllPlansResponse
  planInfo?: PlanInfoById
  planType?: PlanType
  planCountries: string[]
  planPrices?: GetPlanPricesResponse
  planDetail?: PlanDetailById
  planException: string
  planTimestampDetail?: WithItemLog
}
